<template>
  <div class="w-full">
    <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
      What's your current English level?
    </h2>
    <!-- <p class="text-gray-600 mb-6">What's your current English level?</p> -->

    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <OnboardingQuizCard
        v-for="levelOption in levelOptions"
        :key="levelOption.value"
        :is-selected="selectedLevel === levelOption.value"
        :emoji="levelOption.emoji"
        :title="levelOption.label"
        :subtitle="levelOption.description"
        @click="handleLevelSelection(levelOption.value)"
      />

      <div />
    </div>
  </div>
</template>

<script>
import OnboardingQuizCard from '@/components/Onboarding/OnboardingQuizCard.vue'

export default {
  name: 'OnboardingLevelStep',

  components: {
    OnboardingQuizCard
  },

  props: {
    selectedLevel: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      levelOptions: [
        {
          value: 'beginner',
          label: 'Beginner',
          description: 'A1-A2',
          emoji: '🐣'
        },
        {
          value: 'intermediate',
          label: 'Intermediate',
          description: 'B1-B2',
          emoji: '🦅'
        },
        {
          value: 'advanced',
          label: 'Advanced',
          description: 'C1-C2',
          emoji: '🐉'
        }
      ]
    }
  },

  methods: {
    handleLevelSelection(level) {
      this.$emit('level-selected', level)
    }
  }
}
</script>
